const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;

type UTMKey = (typeof UTM_KEYS)[number];

const STORAGE_KEY = 'tracking_utms';

const SENT_FLAG = 'utm_sent_to_cleeng';

export type UTMMap = Partial<Record<UTMKey, string>>;

const CLEENG_QUESTION_MAP: Record<UTMKey, string> = {
  utm_source: 'custom_1',
  utm_medium: 'custom_2',
  utm_campaign: 'custom_3',
  utm_content: 'custom_4',
  utm_term: 'custom_5',
};

export function captureUTMs(): UTMMap {
  const urlParams = new URLSearchParams(window.location.search);
  const stored: UTMMap = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');

  let hasUpdates = false;

  urlParams.forEach((value, key) => {
    const normalizedKey = key.toLowerCase() as UTMKey;

    if (UTM_KEYS.includes(normalizedKey) && value) {
      stored[normalizedKey] = value;
      hasUpdates = true;
    }
  });

  if (hasUpdates) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  }

  return stored;
}

export function getStoredUTMs(): UTMMap {
  return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
}

export function clearUTMs(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export function buildCleengPayload() {
  const utms = getStoredUTMs();

  return Object.entries(utms)
    .filter(([key, value]) => CLEENG_QUESTION_MAP[key as UTMKey] && value)
    .map(([key, value]) => ({
      questionId: CLEENG_QUESTION_MAP[key as UTMKey],
      question: key,
      value,
    }));
}

// export function buildCleengPayload() {
//   const utms = getStoredUTMs();

//   return Object.entries(utms).map(([key, value], id) => ({
//     questionId: `custom_${id + 1}`,
//     question: key,
//     value,
//   }));
// }
export function markUTMsSent() {
  localStorage.setItem(SENT_FLAG, 'true');
}

export function haveUTMsBeenSent(): boolean {
  return localStorage.getItem(SENT_FLAG) === 'true';
}

export function clearAllUTMs(): void {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(SENT_FLAG);
}
